import React, { Suspense } from 'react';

import { useOfflineState } from 'app/src/components/TrelloOffline/useOfflineState';
import { useLazyComponent } from '@trello/use-lazy-component';
import { TrelloOnline } from 'app/src/components/TrelloOnline';

export const App = () => {
  const TrelloOffline = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "trello-offline" */ 'app/src/components/TrelloOffline'
      ),
    { namedImport: 'TrelloOffline', preload: false },
  );

  const wasEverOffline = useOfflineState();

  return wasEverOffline ? (
    <Suspense fallback={null}>
      <TrelloOffline />
    </Suspense>
  ) : (
    <TrelloOnline />
  );
};
